import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './OpenGraphPreview.module.css';
import { api } from '../../api';
import type { OpenGraphData, PreviewType } from '../../api/preview';

interface OpenGraphPreviewProps {
  type?: PreviewType;
  lookupId?: string;
}

const OpenGraphPreview: React.FC<OpenGraphPreviewProps> = ({ 
  type: propType,
  lookupId: propLookupId
}) => {
  const params = useParams<{ type: PreviewType; lookupId: string }>();
  const type = propType || params.type as PreviewType;
  const lookupId = propLookupId || params.lookupId;
  
  const [previewData, setPreviewData] = useState<OpenGraphData | null>(null);

  useEffect(() => {
    const fetchPreviewData = async () => {
      if (!type || !lookupId) return;
      const data = await api.preview.get(type, lookupId);
      setPreviewData(data);
    };

    fetchPreviewData();
  }, [type, lookupId]);

  const handleClick = () => {
    if (previewData?.url) {
      window.open(previewData.url, '_blank', 'noopener,noreferrer');
    }
  };

  if (!previewData) {
    return null;
  }

  const { title, description, image, url } = previewData;
  const displayUrl = url ? new URL(url).hostname.replace('www.', '') : '';
  
  return (
    <div 
      className={styles.container} 
      onClick={handleClick}
      role="button"
      tabIndex={0}
    >
      <div className={styles.imageContainer}>
        {image ? (
          <img 
            src={image} 
            alt={title} 
            className={styles.image}
          />
        ) : (
          <div className={styles.imagePlaceholder}>
            <span>No image available</span>
          </div>
        )}
      </div>
      <div className={styles.content}>
        {url && (
          <div className={styles.urlContainer}>
            <span className={styles.url}>{displayUrl}</span>
          </div>
        )}
        <h3 className={styles.title}>{title || 'No title'}</h3>
        <p className={styles.description}>{description || 'No description available'}</p>
      </div>
    </div>
  );
};

export default OpenGraphPreview;
